import { ErrorBoundary as SentryErrorBoundary } from "@sentry/react";
import React from "react";

import ChunkLoadErrorFallback from "components/ChunkLoadErrorFallback";

const ErrorBoundary = ({ children }: { children?: React.ReactNode }): JSX.Element => (
  <SentryErrorBoundary fallback={({ error }) => <ChunkLoadErrorFallback error={error} />}>
    {children}
  </SentryErrorBoundary>
);

export default ErrorBoundary;
